<template>
  <div class="form-group-simple"
  :class="{
    'form-group-simple--completed': !errors.has('bsn'),
    'form-group-simple--error': errors.has('bsn') || showError}">

    <label for="BSN">{{ label }}</label>

    <input
      ref="input"
      type="text"
      v-model="bsn"
      @input="change"
      :name="name"
      maxlength="9"
      placeholder="012345672"
      @blur="blur">

    <div class="form-group-simple__details">
      <div class="form-group-simple__messages">
        <div class="form-group-simple__error" v-show="errors.has('bsn') && !showError">{{ errors.first('bsn') }}</div>
        <div class="form-group-simple__error" v-if="showError">* Dit veld is verplicht.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
import bsnValidationRules from '@/components/shared/validationRules/bsnValidationRules.js'
import store from '@/store'

export default {
  name: 'v-input-bsn-simple',
  props: {
    autofocus: {
      default: false,
      type: Boolean
    },
    name: {
      default: 'BSN',
      type: String
    },
    label: {
      default: '',
      type: String
    },
    error: {
      default: false,
      type: Boolean
    },
  },
  data () {
    return {
      bsn: '',
      errors: '',
      showError: false
    }
  },
  created () {
    this.validator = new Validator()

    this.validator.attach({
      name: 'bsn',
      rules: bsnValidationRules,
      alias: 'BSN'
    })

    this.$set(this, 'errors', this.validator.errors)
  },
  methods: {
    change (event) {
      if(this.bsn.length > 7) {
        this.validate()
        this.$emit('updateValidation', !this.errors.has('bsn'))
      }
    },
    validate () {
      this.validator.validate('bsn', this.bsn)
    },
    blur () {
      if (store.state.navigation.demo) {
        return
      }
      this.validate()
      return !this.bsn.length ? this.showError = true : this.showError = false
    },
    setFocus () {
      this.$refs.input.focus()
    }
  }
}
</script>